import React, { Suspense } from 'react';
import { ArrowRight, Sparkles, ShieldCheck } from 'lucide-react';
import Hero3DScene from './Hero3DScene';

const TITLE_WORDS = [
  { word: 'INNER', gradient: 'linear-gradient(120deg, #67e8f9, #00d4ff, #38bdf8, #67e8f9)' },
  { word: 'BRIDGE', gradient: 'linear-gradient(120deg, #d8b4fe, #c084fc, #a855f7, #d8b4fe)' },
];

const HeroSection = () => {
  const scrollToCourses = () => {
    const el = document.getElementById('courses');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  let letterIndex = 0;

  return (
    <section id="hero" className="hero-root" data-testid="hero-section">
      {/* ---- 3D WebGL scene: logo, portal rings, nebula, starfield ---- */}
      <div className="hero-canvas" aria-hidden="true">
        <Suspense fallback={null}>
          <Hero3DScene />
        </Suspense>
      </div>

      {/* ---- Grain texture ---- */}
      <div className="hero-grain" aria-hidden="true" />

      {/* ---- DOM overlay content ---- */}
      <div className="hero-overlay">
        <div className="hero-3d-spacer" />

        <h1 className="hero-title" data-testid="hero-title">
          {TITLE_WORDS.map(({ word, gradient }) => (
            <span key={word} className="hero-title-word">
              {word.split('').map((ch, i) => (
                <span
                  key={`${word}-${i}`}
                  className="hero-letter"
                  style={{
                    backgroundImage: gradient,
                    animationDelay: `${0.35 + letterIndex++ * 0.06}s`,
                  }}
                >
                  {ch}
                </span>
              ))}
            </span>
          ))}
        </h1>

        <div className="hero-divider" aria-hidden="true">
          <span className="hero-divider-gem" />
        </div>

        <p className="hero-subtitle" data-testid="hero-subtitle">
          Quantum Spiritual Academy
        </p>

        <div className="hero-badge" data-testid="hero-license-badge">
          <ShieldCheck size={18} className="hero-badge-icon" />
          <div>
            <p className="hero-badge-line1">Licensed in Dubai, U.A.E.</p>
            <p className="hero-badge-line2">License #2646553.01</p>
          </div>
        </div>

        <button className="hero-cta" onClick={scrollToCourses} data-testid="hero-cta-button">
          <Sparkles size={18} />
          <span>Enter Member Area</span>
          <ArrowRight size={18} className="hero-cta-arrow" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
